import { StrictDateRange } from '../../../../features/commonUI/DateRangeFilterSelect/types';
import { useGetClusterReportQuery } from '../../impl/wrangler/endpoints/grape';
import {
  BerriesPerClusterFilter,
  ClusterReportRequest,
  SizeUniformityFilter,
} from '../../impl/wrangler/schemas/clusterReportRequest';

export const useGrapeClusterReport = (
  customerId: string,
  blockIds: string[],
  berriesPerClusterFilter: BerriesPerClusterFilter,
  sizeUniformityFilter?: SizeUniformityFilter,
  dateRange?: StrictDateRange
) => {
  const requestBody: ClusterReportRequest = {
    meta: {
      format: 'json',
    },
    data: {
      customer_id: customerId,
      date_range_start: dateRange?.start.toISOString(),
      date_range_end: dateRange?.end.toISOString(),
      block_ids: blockIds,
      berries_per_cluster: berriesPerClusterFilter,
      size_uniformity: sizeUniformityFilter,
    },
  };

  const { data, isLoading, isFetching } = useGetClusterReportQuery(
    requestBody,
    {
      skip: !customerId || blockIds.length === 0,
    }
  );

  return {
    clusterReportData: data,
    isClusterReportLoading: isLoading || isFetching,
  };
};
